<template>
  <v-app id="home-public" class="primary darken-4">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget
            title="SELECCIONA UNA SUCURSAL"
            color="primary darken-4"
            class="text-center"
            dark
          >
            <div slot="widget-content">
              <v-layout row wrap>
                <v-flex
                  xs12
                  sm6
                  lg3
                  v-for="suc in sucursales"
                  :key="suc.sucursalId"
                >
                  <v-card>
                    <v-img
                      src="/images/sucursal/jaque-sucursal.jpg"
                      aspect-ratio="2.75"
                    ></v-img>

                    <v-card-title primary-title>
                      <div>
                        <h3 class="headline mb-0">{{ suc.nombreSucursal }}</h3>
                        <div>
                          {{ suc.domicilio }}, <br />
                          {{ suc.ciudad }}, {{ suc.estado }}
                        </div>
                        <br />
                        <v-divider></v-divider>
                        <br />
                        <div>
                          <span class="text-primary">Horario: </span>
                          <b>{{ suc.horarioSucursal }}</b>
                        </div>
                      </div>
                    </v-card-title>

                    <v-card-actions class="text-center">
                      <v-btn
                        outline
                        block
                        color="dark"
                        @click="abrirDialogNuevoCliente(suc)"
                        >SELECCIONAR
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>
  </v-app>
</template>

<script>
import VWidget from "@/components/VWidget";

import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

import sucursalService from "@/services/sucursalService";

export default {
  components: {
    VWidget,
    loadingAlert,
    snackBar,
  },
  data() {
    return {
      sucursales: [],
      sucursalSeleccionada: {
        sucursalId: 0,
        nombreSucursal: "",
      },
    };
  },
  beforeCreate() {
    let usuarioId = localStorage.getItem("usuarioId");
    if (!usuarioId) {
      this.$router.push({ path: "public-home" });
    }
  },
  created() {
    this.getSucursales();
  },
  methods: {
    getSucursales() {
      let self = this;
      self.$store.state.loadingInfo.show = true;

      sucursalService
        .getAllPublic()
        .then((result) => {
          self.sucursales = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    abrirDialogNuevoCliente(suc) {
      let self = this;

      self.sucursalSeleccionada = suc;

      if (self.sucursalSeleccionada.sucursalId === 0) {
        self.$store.state.snackbar.color = "error";
        self.$store.state.snackbar.text = "Selecciona una sucursal";
        self.$store.state.snackbar.visible = true;
      } else {
        this.$router.push({
          path: "public-form-cliente",
          query: {
            sucursalId: self.sucursalSeleccionada.sucursalId,
            nombreSucursal: self.sucursalSeleccionada.nombreSucursal,
          },
        });
        // this.$refs.dialogCliente.resetForm();
        // this.$refs.dialogCliente.openDialog();
      }
    },
    onClienteAdded(cliente) {},
    onClienteUpdated(cliente) {},
  },
};
</script>
